/**
 * Convert a float like `0.025` into a percentage like `2.5`
 * Tries to avoid floating point errors
 */
export function floatToPercent(value: number): number {
  return Math.round(value * 10000) / 100;
}
